import type { DialogueLog } from '@shared/types/dialogue-log';
import type { TimelineItem } from '@domain/timeline/model';

/// タイムラインカードのうち編集できるのは手動対話エントリ
/// (`TimelineItem.kind === 'entry'`) のみ。 商談 / 契約から合成された
/// 営業イベントカードは編集対象にしない (dialogue-log-edit 仕様)。
///
/// key は表示イベント id (`entry:${entry.id}` —
/// `timeline-builder.entryToEvents` が生成する形式と一致させる)。
export function editableEntriesByEventId(
  items: ReadonlyArray<TimelineItem>,
): Map<string, DialogueLog> {
  const map = new Map<string, DialogueLog>();
  for (const item of items) {
    if (item.kind === 'entry') {
      map.set(`entry:${item.entry.id}`, item.entry);
    }
  }
  return map;
}
